import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';
import { tableOfContentTab } from './data';

export const gptWars: ProjectContentData = {
  id: 'gpt-wars',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'blockchain-network',
          value: 'BASE',
          name: 'Blockchain Network',
          description: (
            <span>
              The blockchain network
              <br />
              where <b>$GPTW</b> tokens are
              <br />
              issued
            </span>
          ),
        },
        {
          id: '$GPTW',
          value: '$GPTW',
          name: 'Token Ticker',
          description: (
            <span>
              The symbol representing
              <br />
              the token
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '1,000,000,000',
          name: 'Total Supply',
          description: (
            <span>
              The total number of
              <br />
              <b>$GPTW</b> tokens
            </span>
          ),
        },
        {
          id: 'initial-circulation-supply',
          value: '64,100,000',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              The number of <b>$GPTW</b>
              <br />
              tokens that will be
              <br />
              available at TGE
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '$320,500',
          name: 'Initial Market Cap',
          description: (
            <span>
              The market value of
              <br />
              circulating tokens at TGE
            </span>
          ),
        },
        {
          id: 'token-address',
          value: '0xcB0DdC112EF317271266c83D7179Bf9186b9C658',
          name: 'Token Address',
          description: (
            <span>
              The contract address of
              <br />
              the <b>$GPTW</b> token
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$50,000',
          description: (
            <span>
              The total amount <b>$GPTW</b>
              <br />
              aims to raise through the
              <br />
              IDO
            </span>
          ),
        },
        {
          id: 'token-price',
          name: 'Token Price',
          value: '$0.005',
          description: (
            <span>
              The price per <b>$GPTW</b>
              <br />
              token during the IDO
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              The type of crypto
              <br />
              accepted for
              <br />
              participating in the IDO
            </span>
          ),
        },
        {
          id: 'refund-policy',
          name: 'Refund Policy',
          value: '24-hours',
          description: (
            <span>
              The time frame in which
              <br />
              you can request a refund
              <br />
              from TGE
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 4,
      content: [
        {
          id: 'tge',
          value: '20%',
          name: 'At TGE',
          description: (
            <span>
              The percentage of tokens
              <br />
              available for distribution
              <br />
              at TGE
              <br />
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '1 month',
          name: 'Cliff',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-
              <br />
              TGE
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '3 months',
          name: 'Linear Vesting',
          description: (
            <span>
              The time over which the
              <br />
              remaining tokens will be
              <br />
              released
            </span>
          ),
        },
        {
          id: 'magic-launchpad',
          value: 'Magic Launchpad',
          name: 'Distribution Method',
          description: (
            <span>
              The platform handling
              <br />
              the token distribution
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'sale-start',
          value: 'January 20, 2025',
          name: 'Sale Start',
          description: (
            <span>
              The starting date of the
              <br />
              IDO
            </span>
          ),
        },
        {
          id: 'sale-end',
          value: 'January 22, 2025',
          name: 'Sale End',
          description: (
            <span>
              The closing date of the
              <br />
              IDO
            </span>
          ),
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: <span className="whitespace-nowrap">January 23, 2025, 13:00 UTC</span>,
          description: (
            <span>
              The date when the
              <br />
              <b>$GPTW</b> token is listed
            </span>
          ),
        },
        {
          id: 'token-distribution-start',
          name: 'Token Distribution Start',
          value: <span className="whitespace-nowrap">January 23, 2025, 13:10 UTC</span>,
          description: <span>The date of first claim</span>,
        },
      ],
    },
  ],
};
